import { TabType } from 'components/Tabs';

import { Data } from './components/Data';
import { TechnicalFeatures } from './components/TechnicalFeatures';
import { Seo } from './components/Seo';
import { Prices } from './components/Prices';
import { RelatedProducts } from './components/RelatedProducts';
import { Variants } from './components/Variants';
import { Images } from './components/Images';
import { Documents } from './components/Documents';

const tabs: TabType[] = [
  {
    id: 1,
    title: 'Data',
    content: <Data />,
  },
  {
    id: 2,
    title: 'Technical features',
    content: <TechnicalFeatures />,
  },
  {
    id: 3,
    title: 'SEO',
    content: <Seo />,
  },
  {
    id: 4,
    title: 'Prices',
    content: <Prices />,
  },
  {
    id: 5,
    title: 'Related Products',
    content: <RelatedProducts />,
  },
  {
    id: 6,
    title: 'Variants',
    content: <Variants />,
  },
  {
    id: 7,
    title: 'Image',
    content: <Images />,
  },
  {
    id: 8,
    title: 'Documents',
    content: <Documents />,
  },
];

export { tabs };
